/**
 * SVG 글 → PNG 파일(브라우저가 그린다) — 서버가 그려 준 슬라이드 도식(tuningCase/slideRender)을 사례의 그림으로 올리기 위해서다(2026-10-13).
 *
 * 사례의 그림 저장소는 PNG·JPEG·GIF·WEBP 만 받는다(SVG 는 문서로 열리면 스크립트를 돌릴 수 있는 형식이라 받지 않는다). 서버에서 SVG 를
 * 비트맵으로 바꾸려면 네이티브 모듈이 필요한데, 브라우저(웹·스탠드얼론 모두 Chromium)는 이미 그 일을 할 줄 안다.
 *
 * 지키는 것:
 *  · **data: 주소로 싣는다.** blob: 주소로 실은 SVG 는 안에 foreignObject(글)가 있으면 캔버스를 「오염」 시켜 꺼낼 수 없다.
 *  · 크기에 상한을 둔다 — 그림 저장소의 파일 상한(8MB)과 캔버스 한도를 넘지 않게.
 */

/** 배율 2(선명하게), 긴 변 2,400px 까지 */
const DEFAULT_SCALE = 2;
const MAX_SIDE = 2400;

/** 그릴 크기(px) — **순수 함수**. 긴 변이 상한을 넘으면 비율을 지켜 줄인다 */
export function targetSize(width, height, { scale = DEFAULT_SCALE, maxSide = MAX_SIDE } = {}) {
  const w = Math.max(1, Number(width) || 1); const h = Math.max(1, Number(height) || 1);
  const k = Math.min(scale, maxSide / Math.max(w, h));
  return { width: Math.max(1, Math.round(w * k)), height: Math.max(1, Math.round(h * k)) };
}

export const svgDataUrl = (svg) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(String(svg || ''))}`;

/**
 * @param svg  SVG 글(서버가 준 것 — 스크립트가 없고, <img> 로 실으므로 있어도 돌지 않는다)
 * @param name 파일 이름
 * @returns Promise<File> (image/png)
 */
export function svgToPngFile(svg, name = 'figure.png', opts = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onerror = () => reject(new Error('SVG_LOAD_FAILED'));
    img.onload = () => {
      try {
        const size = targetSize(img.naturalWidth, img.naturalHeight, opts);
        const canvas = document.createElement('canvas');
        canvas.width = size.width; canvas.height = size.height;
        canvas.getContext('2d').drawImage(img, 0, 0, size.width, size.height);
        canvas.toBlob((blob) => {
          if (!blob) { reject(new Error('PNG_ENCODE_FAILED')); return; }
          resolve(new File([blob], name, { type: 'image/png' }));
        }, 'image/png');
      } catch (err) { reject(err); }
    };
    img.src = svgDataUrl(svg);
  });
}

export default svgToPngFile;
